export default "__VITE_ASSET__WKd2Y2Ea__"